module.exports = __webpack_public_path__ + "static/media/truffle.ed046993.png";